import { Button, Image } from "antd";
import { char } from "../../../../utils";
import { SignatureAdd } from "./add/signature";
import { useRef, useState } from "react";
import { PhotoAdd } from "./add/photo";
import { useNotification } from "../../../../utils/notification";
import Confirmation from "../../../../utils/confirmation";
import { selector } from "../../../../api";
import { StudentVerification } from "./add/approve";
import { Loader } from "rsuite";
import { gatewayCRUD } from "../../../../actions/gateway";
import { appCRUD } from "../../../../actions/app";



export const StudentInfo = (props) => {
    const { dataId, data, index, setIndex } = props;
    const [open, setOpen] = useState(false)
    const [openPhoto, setOpenPhoto] = useState(false)
    const [openConfirm, setOpenConfirm] = useState(false)
    const [student, setStudent] = useState(null)
    const [loading, setLoading] = useState(false)
    const user = selector.User()
    const openNotification = useNotification();

    const handleApprove = () => {
      setLoading(true)
      setTimeout(() => {
        if (data?.registration_number) {
          gatewayCRUD.approveStudent({
            registration: data?.registration_number,
          }).then((resp) => {
            setStudent(resp.data)
            setOpenConfirm(true);
          }).catch((error) => {
            const responseData = error?.response?.data;
            let errorMessage = "Something went wrong. Please try again.";
            if (typeof responseData === "string") {
              errorMessage = responseData;
            } else if (responseData?.error) {
              errorMessage = responseData.error;
            } else if (responseData?.detail) {
              errorMessage = responseData.detail;
            } else if (responseData?.message) {
              errorMessage = responseData.message;
            } else if (typeof responseData === "object") {
              const firstKey = Object.keys(responseData)[0];
              const firstError = responseData[firstKey];
              if (Array.isArray(firstError)) {
                errorMessage = `${firstError[0]}`;
              }
            }
            openNotification(
              "error",
              "Error",
              <>
                Sorry...!
                <br />
                {errorMessage}
              </>
            );
          }).finally(() => {
            setLoading(false);
          })
        } else {
          openNotification(
            "error",
            "Error",
            <>
              Sorry...!
              <br />
              {"Student not available."}
            </>
          );
          setLoading(false)
        }
      },500)
    }
   
    
    const handleVerify = () => {
      Confirmation(
        `Dear ${char.toTitleCase(user.first_name || "user")}`,
        "are you sure you want to approve this student?",
        handleApprove
      );
    }

    const handlePhoto = () => {
      setLoading(true)
      setTimeout(() => {
        appCRUD
          .patchStudentData(dataId, { photo: null })
          .then(() => {
            openNotification(
              "success",
              "Success",
              <>
                Thank you..!
                <br />
                Student's photo has been cleared successfully..!
              </>
            );
            setIndex(index + 1);
            setOpen(false);
          })
          .catch((error) => {
            const responseData = error?.response?.data;
            let errorMessage = "Something went wrong. Please try again.";
            if (typeof responseData === "string") {
              errorMessage = responseData;
            } else if (responseData?.error) {
              errorMessage = responseData.error;
            } else if (responseData?.detail) {
              errorMessage = responseData.detail;
            } else if (responseData?.message) {
              errorMessage = responseData.message;
            } else if (typeof responseData === "object") {
              const firstKey = Object.keys(responseData)[0];
              const firstError = responseData[firstKey];
              if (Array.isArray(firstError)) {
                errorMessage = `${firstError[0]}`;
              }
            }
            openNotification(
              "error",
              "Error",
              <>
                Sorry...!
                <br />
                {errorMessage}
              </>
            );
          })
          .finally(() => {
            setLoading(false);
          });
      },500)
    }

    const handleClearPhoto = () => {
      Confirmation(
        `Dear ${char.toTitleCase(user.first_name || "user")}`,
        "are you sure you want to clear student's photo?",
        handlePhoto
      );
    };

    const handleSignature = () => {
      setLoading(true);
      setTimeout(() => {
        appCRUD
          .patchStudentData(dataId, { signature: null })
          .then(() => {
            openNotification(
              "success",
              "Success",
              <>
                Thank you..!
                <br />
                Student's signature has been cleared successfully..!
              </>
            );
            setIndex(index + 1);
            setOpen(false);
          })
          .catch((error) => {
            const responseData = error?.response?.data;
            let errorMessage = "Something went wrong. Please try again.";
            if (typeof responseData === "string") {
              errorMessage = responseData;
            } else if (responseData?.error) {
              errorMessage = responseData.error;
            } else if (responseData?.detail) {
              errorMessage = responseData.detail;
            } else if (responseData?.message) {
              errorMessage = responseData.message;
            } else if (typeof responseData === "object") {
              const firstKey = Object.keys(responseData)[0];
              const firstError = responseData[firstKey];
              if (Array.isArray(firstError)) {
                errorMessage = `${firstError[0]}`;
              }
            }
            openNotification(
              "error",
              "Error",
              <>
                Sorry...!
                <br />
                {errorMessage}
              </>
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    };

    const handleClearSignature = () => {
      Confirmation(
        `Dear ${char.toTitleCase(user.first_name || "user")}`,
        "are you sure you want to clear student's signature?",
        handleSignature
      );
    };


    

    return (
      <>
        <StudentVerification
          open={openConfirm}
          setOpen={setOpenConfirm}
          index={index}
          setIndex={setIndex}
          loading={loading}
          setLoading={setLoading}
          dataId={dataId}
          data={student}
        />
        <div className="row">
          <div className="col-12">
            <div className="card shadow border-white p-3">
              <div className="row">
                <div className="col-9 ms-5">
                  <div className="row">
                    <div className="col-md-2 col-sm-5">
                      <p className="h6 fs-14 fw-bold text-primary">
                        Registration No.
                      </p>
                    </div>
                    <div className="col-1">
                      <p className="text-dark fs-14 fw-bold">:</p>
                    </div>
                    <div className="col-md-9 col-5">
                      <p className="text-dark fw-bold fs-13">
                        {data?.registration_number
                          ? data.registration_number
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-2 col-sm-5">
                      <p className="h6 fs-14 fw-bold text-primary">Full Name</p>
                    </div>
                    <div className="col-1">
                      <p className="text-dark fs-14 fw-bold">:</p>
                    </div>
                    <div className="col-md-9 col-5">
                      <p className="text-dark fw-bold fs-13">
                        {data?.full_name
                          ? char.toTitleCase(data.full_name)
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-2 col-sm-5">
                      <p className="h6 fs-14 fw-bold text-primary">Address</p>
                    </div>
                    <div className="col-1">
                      <p className="text-dark fs-14 fw-bold">:</p>
                    </div>
                    <div className="col-md-9 col-5">
                      <p className="text-dark fw-bold fs-13">
                        {data?.address ? char.toTitleCase(data.address) : "N/A"}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-2 col-sm-5">
                      <p className="h6 fs-14 fw-bold text-primary">Phone No.</p>
                    </div>
                    <div className="col-1">
                      <p className="text-dark fs-14 fw-bold">:</p>
                    </div>
                    <div className="col-md-9 col-5">
                      <p className="text-dark fw-bold fs-13">
                        {data?.phone_number ? data.phone_number : "N/A"}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-2 col-sm-5">
                      <p className="h6 fs-14 fw-bold text-primary">Email</p>
                    </div>
                    <div className="col-1">
                      <p className="text-dark fs-14 fw-bold">:</p>
                    </div>
                    <div className="col-md-9 col-5">
                      <p className="text-dark fw-bold fs-13">
                        {data?.email ? data.email : "N/A"}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-2 col-sm-5">
                      <p className="h6 fs-14 fw-bold text-primary">School</p>
                    </div>
                    <div className="col-1">
                      <p className="text-dark fs-14 fw-bold">:</p>
                    </div>
                    <div className="col-md-9 col-5">
                      <p className="text-dark fw-bold fs-13">
                        {data?.school
                          ? char.toTitleCase(data.school.name)
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-2 col-sm-5">
                      <p className="h6 fs-14 fw-bold text-primary">
                        Department
                      </p>
                    </div>
                    <div className="col-1">
                      <p className="text-dark fs-14 fw-bold">:</p>
                    </div>
                    <div className="col-md-9 col-5">
                      <p className="text-dark fw-bold fs-13">
                        {data?.department
                          ? char.toTitleCase(data.department.name)
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-2 col-sm-5">
                      <p className="h6 fs-14 fw-bold text-primary">Programme</p>
                    </div>
                    <div className="col-1">
                      <p className="text-dark fs-14 fw-bold">:</p>
                    </div>
                    <div className="col-md-9 col-5">
                      <p className="text-dark fw-bold fs-13">
                        {data?.programme
                          ? char.toTitleCase(data.programme.name)
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-2 col-sm-5">
                      <p className="h6 fs-14 fw-bold text-primary">Level</p>
                    </div>
                    <div className="col-1">
                      <p className="text-dark fs-14 fw-bold">:</p>
                    </div>
                    <div className="col-md-9 col-5">
                      <p className="text-dark fw-bold fs-13">
                        {data?.qualification_level
                          ? char.toTitleCase(data.qualification_level)
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-2 col-sm-5">
                      <p className="h6 fs-14 fw-bold text-primary">Status</p>
                    </div>
                    <div className="col-1">
                      <p className="text-dark fs-14 fw-bold">:</p>
                    </div>
                    <div className="col-md-2 col-sm-5">
                      {data?.is_verified ? (
                        <span class="badge badge-soft-success badge-border fs-13">
                          {char.toTitleCase("Verified")}
                        </span>
                      ) : (
                        <span class="badge badge-soft-danger badge-border fs-13">
                          {char.toTitleCase("Not Verified")}
                        </span>
                      )}
                    </div>
                    <div className="col-md-2 col-sm-5">
                      {!data?.is_verified &&
                        data?.photo &&
                        data?.signature && (
                          <button
                            onClick={() => handleVerify()}
                            className="btn btn-sm btn-soft-success"
                          >
                            ✅ Verify
                          </button>
                        )}
                    </div>
                  </div>
                </div>
                <div className="col-2 text-end">
                  <div className="row">
                    {data?.photo ? (
                      <div className="col-12 text-center">
                        <Image
                          className="border border-3 border-info"
                          style={{ borderRadius: 10, maxWidth: 200 }}
                          src={data?.photo}
                          alt="student"
                        />
                        {!user.is_student &&  (
                          <button
                            onClick={() => handleClearPhoto()}
                            className="btn btn-sm btn-danger mt-2"
                          >
                            <i className="bi bi-x-circle me-1" />
                            Clear Photo
                          </button>
                        )}
                      </div>
                    ) : (
                      <div className="col-12 text-center">
                        <button
                          className="btn btn-success"
                          onClick={() => setOpenPhoto(true)}
                        >
                          Take a photo
                        </button>
                        <PhotoAdd
                          open={openPhoto}
                          setOpen={setOpenPhoto}
                          studentId={data?.id}
                        />
                      </div>
                    )}
                  </div>
                  <div className="row mt-3">
                    {data?.signature ? (
                      <div className="col-12 text-center">
                        <Image
                          style={{ borderRadius: 10, maxWidth: 150 }}
                          src={data?.signature}
                          alt="student"
                        />
                        {!user.is_student && (
                          <button
                            onClick={() => handleClearSignature()}
                            className="btn btn-sm btn-danger mt-2"
                          >
                            <i className="bi bi-x-circle me-1" />
                            Clear Signature
                          </button>
                        )}
                      </div>
                    ) : (
                      <div className="col-12 text-center">
                        <button
                          className="btn btn-info"
                          onClick={() => setOpen(true)}
                        >
                          signature
                        </button>
                        <SignatureAdd
                          open={open}
                          setOpen={setOpen}
                          studentId={data?.id}
                        />
                      </div>
                    )}
                  </div>
                  {/* <div>
                    <Webcam
                      audio={false}
                      ref={webcamRef}
                      screenshotFormat="image/jpeg"
                      width={300}
                    />
                    <button onClick={capture}>Capture</button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {loading && (
          <Loader
            size="lg"
            speed="slow"
            center
            backdrop
            style={{ color: "#d26e29" }}
            content="Please wait..."
            vertical
          />
        )}
      </>
    );

}